@if (fieldSet().includes(ServiceDataFields.RecentPregnancy) && isRelevant()) {
  <div class="row mb-3">
    <div class="col-12 col-md-6">
      <div class="row align-items-center">
        <div class="col-12 col-sm-6 col-md-4 mb-1">
          <label>{{
            'serviceData.form.nippt.recentPregnancy' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-6 col-md-8">
          @for (answer of [true, false]; track answer) {
            <div class="form-check form-check-inline form-check-lg">
              <input
                class="form-check-input me-2"
                type="radio"
                formControlName="wasPregnant"
                [id]="'recentPregnancy' + answer"
                [attr.data-cy]="
                  ServiceDataFields.RecentPregnancy +
                  '-radio-' +
                  (answer ? 'yes' : 'no')
                "
                [value]="answer"
              />
              <label
                class="form-check-label"
                [for]="'recentPregnancy' + answer"
              >
                {{ (answer ? 'common.yes' : 'common.no') | translate }}
              </label>
            </div>
          }
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-6 col-md-8">
          <app-validation-error
            for="wasPregnant"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  </div>
  @if (wasPregnant()) {
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="recentPregnancyOutcome">{{
              'serviceData.form.nippt.recentPregnancyOutcome' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <app-select
              class="w-100"
              id="recentPregnancyOutcome"
              formControlName="type"
              [attr.data-cy]="
                ServiceDataFields.RecentPregnancy + '-outcome-select'
              "
              [placeholder]="
                'serviceData.form.nippt.recentPregnancyOutcomePlaceholder'
                  | translate
              "
            >
              @for (outcome of outcomes; track outcome) {
                <app-select-option
                  [value]="outcome"
                  [label]="
                    'serviceData.form.nippt.recentPregnancyOutcomes.' + outcome
                      | translate
                  "
                />
              }
            </app-select>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="type"
              translations="validation.generic"
            />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="recentPregnancyOutcomeDate">{{
              'serviceData.form.nippt.recentPregnancyOutcomeDate' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              ngbDatepicker
              class="form-control"
              id="recentPregnancyOutcomeDate"
              formControlName="date"
              appInputValidationStatus
              container="body"
              #outcomeDatepicker="ngbDatepicker"
              [attr.data-cy]="ServiceDataFields.RecentPregnancy + '-date-input'"
              [minDate]="momentToNgbDate(minDate)"
              [maxDate]="momentToNgbDate(maxDate)"
              [placeholder]="
                'serviceData.form.placeholders.dateFormat' | translate
              "
              (click)="outcomeDatepicker.toggle()"
            />
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="date"
              translations="validation.generic"
            />
          </div>
        </div>
      </div>
    </div>
  }
}
